<template>
<div class="swiper-slide-inner">
    <div class="step" v-if="showBrand || showShowroom || showShop">
        <p>STEP<span>01</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>会社名（法人名）を教えてください(個人事業主は店舗名)</span></h3>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <input v-on:input="isDisabledNextButton" type="text" id="company-name" placeholder=" " v-model="company_name" required>
                    <label for="company-name" class="m-label"><span>会社名（法人名）</span></label>
                </div>
                <div class="item form_text">
                    <input v-on:input="isDisabledNextButton" type="text" id="company-phonetic" placeholder=" " v-model="company_phonetic" required>
                    <label for="company-phonetic" class="m-label"><span>会社名（法人名）フリガナ</span></label>
                </div>
                <div class="item form_text">
                    <input v-on:input="isDisabledNextButton" type="text" id="company-post-code" placeholder="ハイフン有りで入力" v-model="company_post_code" required>
                    <label for="company-post-code" class="m-label"><span>郵便番号</span></label>
                </div>
                <div class="item form_text">
                    <input v-on:input="isDisabledNextButton" type="text" id="company-address" placeholder=" " v-model="company_address" required>
                    <label for="company-address" class="m-label"><span>住所</span></label>
                </div>
                <div class="item form_text">
                    <input v-on:input="isDisabledNextButton" type="tel" pattern="[0-9]*"  id="company-tel" placeholder="ハイフン無しで入力" v-model="company_tel" required>
                    <label for="company-tel" class="m-label"><span>電話番号</span></label>
                </div>
                <!-- <div v-if="showBrand" class="item form_select">
                    <select v-on:change="isDisabledNextButton" v-model="selectedCompanyKind" name="" id="company-genre" required>
                        <option value="" disabled selected style='display:none;'>選択して下さい</option>
                        <option v-for="companyKind in optionCompanyKind" v-bind:key="companyKind.id" v-bind:value="companyKind.name" >
                            {{ companyKind.name }}
                        </option>
                    </select>
                    <label for="company-genre"><span>会社種別</span></label>
                </div> -->
            </div>
        </div>

        <div class="control-wrap">
            <button v-if="showShop || showBrand || showShowroom" type="button" class="_left js-swiper-prev" v-on:click="$emit('showPrevSwiper')"><span>Back</span></button>
            <!-- <button v-if="showShowroom" type="button" class="_left js-swiper-prev" disabled><span></span></button> -->

            <button v-on:click="inputCompanyName" v-bind:disabled="isDisabled" type="button" v-bind:class="isDisabled? '_left' : '_right'" class="js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>
<style>
input:not(:focus)::-webkit-input-placeholder {
	color: transparent;
}
input:not(:focus)::-moz-placeholder {
	color: transparent;
}
input:not(:focus)::-ms-input-placeholder {
	color: transparent;
}
input:not(:focus)::placeholder {
	color: transparent;
}
</style>

<script>
    export default {
        data() {
            return {
                isDisabled: false,
                company_name: '',
                company_phonetic: '',
                company_post_code: '',
                company_address: '',
                company_tel: '',
                // selectedCompanyKind: '',
                // optionCompanyKind: [
                //     { id: 1, name: '制作者' },
                //     { id: 2, name: 'メーカー' },
                //     { id: 3, name: 'ショールーム' }
                // ],
            }
        },
        /**
         * ブラウザ読み込み時に最初のv-bind:disabledが自動で無効とされてしまうため
         * やむなくmountedで解消しています
         */
        mounted() {
            this.isDisabled = true;

            if (this.showBrand) {
                this.$store.state.verify.form.registration_plan = 0;
            } else if (this.showShowroom) {
                this.$store.state.verify.form.registration_plan = 20;
            }
        },
        methods: {
            inputCompanyName() {
                this.$store.state.verify.form.company_name = this.company_name;
                this.$store.state.verify.form.company_phonetic = this.company_phonetic;
                this.$store.state.verify.form.company_post_code = this.company_post_code;
                this.$store.state.verify.form.company_address = this.company_address;
                this.$store.state.verify.form.company_tel = this.company_tel;
                // this.$store.state.verify.form.company_kind = this.selectedCompanyKind;
                this.$emit('showNextSwiper');
            },
            validCompnyInfo() {
                this.isDisabled = true;
                if (this.company_name && this.company_name.match(/\S/g) && this.company_phonetic && this.company_post_code && this.company_address && this.company_tel) {
                    const reg_tel = new RegExp(/^(0{1}\d{9,10})$/); //ハイフンなしで実装 ハイフンありの場合 /^0[789]0-[0-9]{4}-[0-9]{4}$/
                    const val_tel = reg_tel.test(this.company_tel);

                    const reg_post_code= new RegExp(/^[0-9]{3}-[0-9]{4}$/); //ハイフンありで実装
                    const val_post_code = reg_post_code.test(this.company_post_code);
                    if (val_tel && val_post_code) {
                        this.isDisabled = false;
                    }
                }
            },
        },
        computed: {
            isDisabledNextButton() {
                return this.validCompnyInfo();
            },
            showShop() {
                return location.pathname.match(/^\/registration\/shop/);
            },
            showBrand() {
                return location.pathname.match(/^\/registration\/brand/);
            },
            showShowroom() {
                return location.pathname.match(/^\/registration\/showroom/);
            },
        }
    }
</script>
